export const publicUrls = ['/plans', '/login', '/web-views/payment-link', '/web-views/payment-link-list', '/web-views/payment-link-setup-success'];

export const authNoPlus = ['/profile', '/plans'];
